import {CustomNavLink} from '../components/customNavLink/CustomNavLink.tsx'
import {routes} from '../routes.ts'
import {IconCalendarWeek, IconChartBar, IconLayoutList, IconPlugConnected} from '@tabler/icons-react'

export const NavigationItems = () => {
  return (
    <>
      <CustomNavLink to={routes.dashboard.buildRoute()} leftSection={<IconChartBar stroke={1} />} label={'Dashboard'} />
      <CustomNavLink
        to={routes.calendar.buildRoute()}
        leftSection={<IconCalendarWeek stroke={1} />}
        label={'Calendar'}
      />
      <CustomNavLink to={routes.projects.buildRoute()} leftSection={<IconLayoutList stroke={1} />} label={'Projects'} />
      <CustomNavLink
        to={routes.connections.buildRoute()}
        leftSection={<IconPlugConnected stroke={1} />}
        label={'Connections'}
      />
    </>
  )
}
